import { useState } from "react";
import OperacionesCambioDeudor from "./OperacionesCambioDeudor";
import SeleccionarPersonaModal from "../../Comunes/PersonaUnificada/SeleccionarPersonaModal";
import DatosBasicosPersona from "../../Comunes/PersonaUnificada/DatosBasicosPersona";

function SolicitudCambioDeudor({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
}) {
  const [datosSolicitudCambioDeudor, setDatosSolicitudCambioDeudor] = useState({
    operaciones: datosSolicitud.operaciones,
    nuevoDeudor: datosSolicitud.nuevoDeudor,
    datosNuevoDeudor: datosSolicitud.datosNuevoDeudor,
  });

  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosSolicitudCambioDeudor,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarNuevoDeudor(persona) {
    const nuevosDatos = {
      ...datosSolicitudCambioDeudor,
      nuevoDeudor: persona.identificacionPrincipal,
      datosNuevoDeudor: persona,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setDatosSolicitudCambioDeudor(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }

  const botonModalSeleccionarDeudor = (
    <button className="btn btn-primary btn-sm btn-icon-split mb-3">
      <span className="icon text-white-50">
        <i className="fas fa-plus-circle"></i>
      </span>
      <span className="text">Asignar Nuevo Deudor</span>
    </button>
  );

  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-header">
          <h6 className="m-0 font-weight-bold text-primary">Nuevo Deudor</h6>
        </div>
        <div className="card-body">
          <SeleccionarPersonaModal
            boton={botonModalSeleccionarDeudor}
            actualizarPersona={actualizarNuevoDeudor}
          />

          {datosSolicitudCambioDeudor.datosNuevoDeudor ? (
            <DatosBasicosPersona
              personaUnificada={datosSolicitudCambioDeudor.datosNuevoDeudor}
            />
          ) : (
            <div className="alert alert-warning" role="alert">
              No se ha seleccionado el nuevo deudor.
            </div>
          )}
        </div>
      </div>

      <OperacionesCambioDeudor
        operaciones={datosSolicitudCambioDeudor.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEliminar="true"
      />
    </>
  );
}

export default SolicitudCambioDeudor;
